import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const ShipmentDebugView = ({ shipment }) => {
  const [show, setShow] = useState(false);

  if (process.env.NODE_ENV !== "development") return null;

  return (
    <>
      <div style={{ textAlign: "right", padding: "2px 8px" }}>
        <span
          onClick={() => setShow(true)}
          style={{ fontSize: "11px", color: "#aaa", cursor: "pointer", userSelect: "none" }}
        >
          [debug]
        </span>
      </div>

      <Modal show={show} onHide={() => setShow(false)} size="lg" scrollable>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "15px" }}>
            Shipment Object — ID {shipment?.id}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <pre style={{ fontSize: "12px", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {JSON.stringify(shipment, null, 2)}
          </pre>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ShipmentDebugView;
